export const formatPhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber) return '';

  if (phoneNumber.includes(' ') || phoneNumber.includes('(')) {
    return phoneNumber;
  }

  if (phoneNumber.startsWith('+')) {
    const countryCode = phoneNumber.substring(
      0,
      phoneNumber.length > 3 ? 2 : 1
    );
    const remaining = phoneNumber.substring(countryCode.length);

    if (remaining.length === 10) {
      return `${countryCode} (${remaining.substring(
        0,
        3
      )}) ${remaining.substring(3, 6)}-${remaining.substring(6)}`;
    }
  }

  if (phoneNumber.length === 10 && !phoneNumber.startsWith('+')) {
    return `+1 (${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(
      3,
      6
    )}-${phoneNumber.substring(6)}`;
  }

  if (phoneNumber.length === 11 && phoneNumber.startsWith('1')) {
    return `+1 (${phoneNumber.substring(1, 4)}) ${phoneNumber.substring(
      4,
      7
    )}-${phoneNumber.substring(7)}`;
  }

  if (!phoneNumber.startsWith('+')) {
    return `+${phoneNumber}`;
  }

  return phoneNumber;
};
